import { ExportReason, TaxId } from '~/apps/smartsend/lib/consts/ItemMetaConstants';
import { SmartSendItemApiModel } from './types';
export const ddpQuoteKey = (provider: string, accountId: string, item: SmartSendItemApiModel) => {
  const sections: string[] = ['ddp'];

  // Service
  sections.push(item.Service?.Id ?? 'NO-SERVICE');

  // Account
  sections.push(encodeURIComponent(provider));
  sections.push(encodeURIComponent(accountId));

  // Export Reason
  sections.push('C');
  sections.push(item.Meta[ExportReason]?.Value ?? 'NO-EXPORT-REASON');

  // Sender
  sections.push('S');
  sections.push(item.Sender.CountryIsoCode);
  sections.push(item.Sender.CountrySubdivision ?? '');
  sections.push(item.Sender.Postcode ?? '');
  sections.push(item.Sender.VatStatus ?? 'NO-VAT-STATUS');
  sections.push(item.Sender.VatNumber ?? 'NO-VAT-NUMBER');
  sections.push(item.Sender.Meta[TaxId]?.Value ?? 'NO-TAX-ID');

  // Recipient
  sections.push('R');
  sections.push(item.Recipient.CountryIsoCode);
  sections.push(item.Recipient.CountrySubdivision);
  sections.push(item.Recipient.Postcode);
  sections.push(item.Recipient.VatStatus ?? 'NO-VAT-STATUS');
  sections.push(item.Recipient.VatNumber ?? 'NO-VAT-NUMBER');
  sections.push(item.Recipient.Meta[TaxId]?.Value ?? 'NO-TAX-ID');

  // Item / Contents
  sections.push('I');
  sections.push(item.PackageDimensions.Weight?.toString() ?? 'NO-WEIGHT');
  sections.push(item.Value?.toString() ?? 'NO-VALUE');
  sections.push(
    item.MarketplaceOrderLines.map((e) => `${e.Product?.TariffCode}_${e.Value}_${e.Product.CountryOfManufacture}`).join(
      '~'
    )
  );

  return sections.join('_').toLowerCase();
};
